import utils from './utils';

const URL = `${BASE_API_URL}/products`;

export default {
    getPaymentData: (productId, data) => utils.get(`${URL}/payment/${productId}.json`, data),
    createPayment: (productId, data) => utils.post(`${URL}/payment/${productId}.json`, data),
}



// WEBPACK FOOTER //
// ./src/api/products.js